import type { AreaRoute } from "./areaRoute";
import { OperationsData } from "../../auth/roles";
import { lazyPage } from "../../lib/lazyPage";
const AskViperPage = lazyPage(() => import("../viper/AskViperPage"), "AskViperPage");
const ClearancePage = lazyPage(() => import("../viper/ClearancePage"), "ClearancePage");
const KnowledgeIndexPage = lazyPage(() => import("../viper/KnowledgeIndexPage"), "KnowledgeIndexPage");

// VIPER area (VIPER-1 core, release 0.3.0): the full /viper page, its sub-pages, and the admin pages that govern the AI
// (AI activity, content clearance, knowledge index).
export const MorningBriefPage = lazyPage(() => import("../hubs/ViperPages"), "MorningBriefPage");
export const ScenarioLabPage = lazyPage(() => import("../hubs/ViperPages"), "ScenarioLabPage");
export const RebalancePage = lazyPage(() => import("../hubs/ViperPages"), "RebalancePage");
export { AskViperPage, ClearancePage, KnowledgeIndexPage };
export const AiActivityPage = lazyPage(() => import("../admin/AiActivityPage"), "AiActivityPage");

export const viperRoutes: AreaRoute[] = [
  {
    path: "/viper/sessions/:sessionId",
    allow: OperationsData,
    element: <AskViperPage />
  }
];


